import ColumnBase from "./ColumnBase.jsx";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { SWIVU_STANDARD_ICONS } from "../../other/constants/IconKeys.jsx";
import { ICON_COL_DEF_WIDTH, VIEW_TYPES } from "../../other/constants/OtherKeys.jsx";
import { ColumnStore, EventHelper, Tooltip } from "@bryntum/schedulerpro";
import { copyTextToClipboard } from "../../other/utils/utils.jsx";
import { EDITOR_KEYS } from "../../other/constants/EditorKeys.jsx";

export default class ContactColumn extends ColumnBase {
  static get $name() {
    return "ContactColumn";
  }

  static get type() {
    return WIDGET_KEYS.contactColumn;
  }

  static get defaults() {
    return {
      text: "Contact",
      width: 30,
      minWidth: ICON_COL_DEF_WIDTH,
      editor: false,
      searchable: "center",
      align: "center",
      cellCls: "cursor-pointer",
      cls: "swivu-icon-column",
      sealed: true,
      filterable: false,
      htmlEncode: false,
      field: "hasContacts",
      headerRenderer() {
        return `<i class="${SWIVU_STANDARD_ICONS[VIEW_TYPES.contacts]}"/>`
      },
      renderer({ value }) {
        return `<i class="${SWIVU_STANDARD_ICONS[VIEW_TYPES.contacts]} swivu-icon-tooltip ${value ? 'text-[#0a88e9]' : ''}"/>`
      },
      groupRenderer({ groupRowFor }) {
        return `<i class="${SWIVU_STANDARD_ICONS[VIEW_TYPES.contacts]} ${groupRowFor ? 'text-[#0a88e9]' : ''}"/>`
      },
    }
  }

  onLoad(project, otherParams) {
    this.project = project;
    this.otherParams = otherParams;
    if (!this.swivuContactTooltip) {
      this.swivuContactTooltip = new Tooltip({
        forElement: this.grid.element,
        forSelector: ".swivu-icon-tooltip",
        allowOver: true,
        cls: "swivu-contact-tooltip",
        scrollable: true,
        getHtml: this.getContactTooltipContent.bind(this),
      })
      this.on({
        destroy: this.onColumnDestroy,
        thisObj: this,
        once: true,
      })
    }
  }

  getContactTooltipContent({ activeTarget, tip }) {
    const record = this.grid.getRecordFromElement(activeTarget);
    if (record.contacts.length) {
      if (this.onTooltipClick) {
        this.onTooltipClick();
        this.onTooltipClick = null;
      }
      this.onTooltipClick = EventHelper.on({
        element: tip.element,
        click: (e) => this.onContactClick(e, record),
        thisObj: this
      })
      return  {
        children: [{
          tag: "div",
          class: "swivu-contact-tooltip-content",
          children: record.contacts.map(({ contactRecord }) => {
            const contactPills = [{ tag: "div", class: "contact-pill contact-header", text: contactRecord.name }];

            if (contactRecord.email) {
              contactPills.push({
                tag: "div",
                class: "contact-pill contact-email",
                text: contactRecord.email
              });
            }
            if (contactRecord.phone) {
              contactPills.push({
                tag: "div",
                class: "contact-pill contact-phone",
                text: contactRecord.phone
              });
            }

            return {
              tag: "div",
              dataset: {
                contactId: contactRecord.id
              },
              class: "tooltip-contact-container",
              children: contactPills
            }
          })
        }]
      }
    } else {
      tip.hide();
    }
  }

  onContactClick(event, record) {
    if (this.onContactTimeout) clearTimeout(this.onContactTimeout);

    this.onContactTimeout = setTimeout(() => {
      const tooltipContactContainerEl = event.target.parentElement;
      if (!tooltipContactContainerEl.classList.contains("tooltip-contact-container")) return;

      const contactRecord = this.project.contactsStore.getById(tooltipContactContainerEl.dataset.contactId);
      let pillType = "phone";

      if (event.target.classList.contains("contact-header")) {
        pillType = "header";
      } else if (event.target.classList.contains("contact-email")) {
        pillType = "email";
      }

      switch (pillType) {
        case "header":
          // for dblClick on header
          if (event.detail === 2) {
            this.otherParams.editorHandler.openEditor(EDITOR_KEYS.contactFinder, contactRecord, {
              contactRecord,
              clientRecord : record.isClient ? record : null
            }, {
              by: "recordType", useExisting: true,
            });
          } else {
            copyTextToClipboard(`${contactRecord.name}\n${contactRecord.email}\n${contactRecord.phone}`, `${contactRecord.name} has been copied to clipboard`);
          }
          break;
        case "email":
          copyTextToClipboard(contactRecord.email, `${contactRecord.name}'s email has been copied to clipboard`);
          break;
        default:
          copyTextToClipboard(contactRecord.phone, `${contactRecord.name}'s phone number has been copied to clipboard`);
          break;
      }
    }, 800);
  }


  onColumnDestroy() {
    this.swivuContactTooltip.destroy();
    if (this.onTooltipClick) {
      this.onTooltipClick();
      this.onTooltipClick = null;
    }
  }
}

ColumnStore.registerColumnType(ContactColumn);
